import { Component, input } from '@angular/core';

@Component({
  selector: 'app-custom-distance-column',
  standalone: true,
  imports: [],
  templateUrl: './custom-distance-column.component.html',
  styleUrl: './custom-distance-column.component.scss'
})
export class CustomDistanceComponent {
  public value = input<string>()
  public rowData = input<any>()
  public field = input<string>()
}
